import * as Yup from "yup";

const purchaseReturnSchema = {};

purchaseReturnSchema.validateAdd = (values) => {
  let schema = Yup.object({
    po_id: Yup.string().required("Purchase No is Required."),
    buyer_id: Yup.string().required("Supplier Name is Required."),
    branch_id: Yup.string().required("Branch Name is Required."),
    trans_date: Yup.string().required("Transaction Date is Required."),
    reason: Yup.string()
      .required("Reason  is Required."),
      // .matches(/^[a-zA-Z0-9\s]+$/, "Reason must be alphanumeric characters."),
    item_dtl: Yup.array()
      .of(
        Yup.object({
          item_id: Yup.string().required("Item Name is Required"),
          qty: Yup.string().required("Item Qty is Required"),
          amount: Yup.string().required("Item Price is Required"),
          godown_id: Yup.string().required("Godown Name is Required"),
        })
      )
      .min(1, "Invalid Product Details."),
  });

  return schema.validate(values, { abortEarly: false }).catch((err) => err);
};

export default purchaseReturnSchema;
